export enum ItemType {
  PILL = 'pill',
}
